var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCodEnabled)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Cash on delivery'),expression:"'Cash on delivery'"}],staticClass:"badge-cod"},[_vm._v("COD")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }